<template lang="pug">
  span {{ formatDate(value, format) }}
</template>

<script>
import { formatDate } from '@/utils/helper';

export default {
  props: {
    value: {
      type: String,
      required: true,
    },

    format: {
      type: String,
      default: 'dd-MM-yyyy HH:mm',
    },
  },

  methods: {
    formatDate,
  },
};
</script>
